export default __webpack_public_path__ + "2c3f4c5a782b2bc84934b3a415a17858.svg";